import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { Client } from "@twilio/conversations";
import { Spinner } from "../../ui";
import { useAPI } from "../../hooks";

import { useEffect, useState } from "react";
import { ChatLayout } from "../layouts";

export const ChatPage = () => {
  const { tokenChat } = useSelector((state) => state.chats);
  const [conversation, setConversation] = useState(null);
  const [userCanReply, setUserCanReply] = useState(false);
  const [integrationNumber, setIntegrationNumber] = useState("");
  const { id } = useParams();
  const { get } = useAPI();

  const loadService = async () => {
    if (tokenChat === "" || conversation !== null) return;
    const { isSuccess, data } = await get(`/chat/get-conversation/${id}`);
    if (!isSuccess) return;
    const { tokenConversation, userCanReply, service } = data.data;
    setIntegrationNumber(service.integrationNumber);
    setUserCanReply(userCanReply);
    const conversationTwilio = await loadConversation(tokenConversation);
    setConversation(conversationTwilio);
    return;
  };

  const loadConversation = async (tokenConversation = "") => {
    const client = new Client(tokenChat);
    if (conversation) return;
    const conversationTwilio = await joinConversation(
      client,
      tokenConversation
    );
    client.removeAllListeners("connectionStateChanged");
    return conversationTwilio;
  };

  const joinConversation = async (client, tokenConversation) => {
    return new Promise((resolve, reject) => {
      client.on("connectionStateChanged", async (state) => {
        if (state === "denied") return reject("No se pudo conectar");
        if (state !== "connected") return;
        const conversationTwilio = await client.getConversationBySid(
          tokenConversation
        );
        await client.removeAllListeners("connectionStateChanged");
        resolve(conversationTwilio);
      });
    });
  };

  useEffect(() => {
    loadService();
  }, []);

  if (conversation === null) {
    return <Spinner />;
  }
  return (
    <div>
      <h1 className="text-2xl font-bold">
        Chat de Servicio No. Integración:{integrationNumber}
      </h1>
      <ChatLayout conversation={conversation} userCanReply={userCanReply} serviceId={id} />
    </div>
  );
};
